import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'core-js/modules/es6.array.fill.js';
import 'core-js/modules/es6.string.small.js';
import 'core-js/modules/es6.object.keys.js';
import 'core-js/modules/es6.symbol.js';
import 'core-js/modules/es6.array.filter.js';
import 'core-js/modules/es6.object.get-own-property-descriptor.js';
import 'core-js/modules/es7.object.get-own-property-descriptors.js';
import { Classes, Spinner } from '@blueprintjs/core';
import React__default, { forwardRef } from 'react';
import cx from 'classnames';
import { Icon } from '../icon/icon.js';

var _excluded = ["active", "alignText", "fill", "large", "loading", "outlined", "minimal", "small", "tabIndex", "icon", "rightIcon", "children", "type", "text", "useAnchor", "role", "id"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function isReactNodeEmpty(node) {
  var skipArray = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return node == null || node === "" || node === false || !skipArray && Array.isArray(node) && ( // only recurse one level through arrays, for performance
  node.length === 0 || node.every(function (n) {
    return isReactNodeEmpty(n, true);
  }));
}

var Button = /*#__PURE__*/forwardRef(function (props, ref) {
  var _cx;

  var _props$active = props.active,
      active = _props$active === void 0 ? false : _props$active,
      alignText = props.alignText,
      fill = props.fill,
      large = props.large,
      loading = props.loading,
      outlined = props.outlined,
      minimal = props.minimal,
      small = props.small,
      tabIndex = props.tabIndex,
      IconIncoming = props.icon,
      RightIconIncoming = props.rightIcon,
      children = props.children,
      _props$type = props.type,
      type = _props$type === void 0 ? "button" : _props$type,
      text = props.text,
      useAnchor = props.useAnchor,
      role = props.role,
      id = props.id,
      remainingProps = _objectWithoutProperties(props, _excluded);

  var disabled = props.disabled || loading;
  var className = cx(Classes.BUTTON, (_cx = {}, _defineProperty(_cx, Classes.ACTIVE, !disabled && active), _defineProperty(_cx, Classes.DISABLED, disabled), _defineProperty(_cx, Classes.FILL, fill), _defineProperty(_cx, Classes.LARGE, large), _defineProperty(_cx, Classes.LOADING, loading), _defineProperty(_cx, Classes.MINIMAL, minimal), _defineProperty(_cx, Classes.OUTLINED, outlined), _defineProperty(_cx, Classes.SMALL, small), _cx), alignText ? Classes.alignmentClass(alignText) : undefined, Classes.intentClass(props.intent), props.className);
  var ButtonElement = disabled || useAnchor ? "a" : "button";

  var buttonProps = _objectSpread(_objectSpread({}, remainingProps), {}, {
    className: className,
    disabled: disabled,
    onClick: disabled ? undefined : props.onClick,
    tabIndex: disabled ? -1 : tabIndex,
    role: disabled && "button",
    "aria-disabled": disabled
  });

  return /*#__PURE__*/React__default.createElement(ButtonElement, _extends({
    ref: ref,
    type: !disabled && !useAnchor ? type : undefined
  }, buttonProps, {
    role: role,
    id: id
  }), loading && /*#__PURE__*/React__default.createElement(Spinner, {
    key: "loading",
    className: Classes.BUTTON_SPINNER,
    size: 20
  }), IconIncoming ? /*#__PURE__*/React__default.createElement(Icon, null, /*#__PURE__*/React__default.createElement(IconIncoming, null)) : null, (!isReactNodeEmpty(text) || !isReactNodeEmpty(children)) && /*#__PURE__*/React__default.createElement("span", {
    key: "text",
    className: Classes.BUTTON_TEXT
  }, text, children), RightIconIncoming && /*#__PURE__*/React__default.createElement(Icon, null, /*#__PURE__*/React__default.createElement(RightIconIncoming, null)));
});

export { Button };
//# sourceMappingURL=button.js.map
